import PropTypes from "prop-types";
import PromptIcon from "../../../navigation/prompt-icon";
import { getCategoryPath } from "helpers/category-helpers";

const propTypes = {
  typeaheadPrompts: PropTypes.array,
  isHamburgerOpen: PropTypes.bool,
  setSearchQuery: PropTypes.func,
  setTypeaheadPrompts: PropTypes.func,
  showSearchField: PropTypes.bool,
};

const SearchResults = props => {
  const { typeaheadPrompts, isHamburgerOpen, setSearchQuery, showSearchField, setTypeaheadPrompts } = props;
  const executeTypeaheadSearch = typeaheadResult => {
    const id = typeaheadResult.id;

    if (typeaheadResult.type === "curation") {
      return `/shop/${id}/products`;
    } else if (typeaheadResult.type === "designer") {
      return `/designers/${id}/products`;
    } else if (typeaheadResult.type === "category") {
      const categoryPath = getCategoryPath(id);
      return !categoryPath ? `/products/clothing?filters[searchText]=${typeaheadResult.displayName}` : categoryPath;
    }
  };

  const queryPrompt = term => {
    const form = document.getElementById("search-bar-form");
    setSearchQuery(term);
    form.elements["filters[searchText]"].value = term;
    form.submit();
  };

  const handleClear = () => {
    setSearchQuery("");
    setTypeaheadPrompts([]);
  };

  const promptsArr = typeaheadPrompts;

  return (
    <div
      data-test-id="searchbar-results-wrapper"
      className={`${
        showSearchField || isHamburgerOpen ? "block" : "hidden"
      } bg-white border border-t-0 border-current rounded-b-lg max-h-60 overflow-auto`}>
      <ul data-test-id="searchbar-results-list">
        <li className="grid grid-cols-2 font-semibold items-center !text-sm md:!text-md px-4 pt-3">
          <div>SUGGESTIONS</div>
          {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions, jsx-a11y/click-events-have-key-events */}
          <div
            data-test-id="searchbar-results-clear"
            className={`text-right ${isHamburgerOpen ? "block" : "hidden"}`}
            role="presentation"
            onClick={handleClear}>
            X
          </div>
        </li>
        {promptsArr.map(item =>
          executeTypeaheadSearch(item) ? (
            // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions, jsx-a11y/click-events-have-key-events
            <li data-test-id="searchbar-results-item" key={item.id} onMouseDown={e => e.preventDefault()}>
              <a
                className="grid grid-cols-2 items-center hover:bg-[#F7F7F7] py-4 pr-4 !text-sm md:!text-md"
                href={executeTypeaheadSearch(item)}
                data-heap-id={`typeahead-prompt-${item.type}`}>
                <div className="flex flex-row gap-6">
                  <div className="[&>svg]:h-4 [&>svg]: w-4">
                    <PromptIcon type={item.type} />
                  </div>
                  <div>{item.displayName}</div>
                </div>
                <div className="text-right capitalize text-[#707070]">{item.type}</div>
              </a>
            </li>
          ) : (
            // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions, jsx-a11y/click-events-have-key-events
            <li
              data-test-id="searchbar-results-item"
              className="grid grid-cols-2 items-center hover:bg-[#F7F7F7] py-4 pr-4 !text-sm md:!text-md"
              key={item}
              onMouseDown={e => e.preventDefault()}
              onClick={() => queryPrompt(item.displayName)}>
              <span>{item.displayName}</span>
              <span className="text-right capitalize text-[#707070]">{item.type}</span>
            </li>
          )
        )}
      </ul>
    </div>
  );
};
SearchResults.propTypes = propTypes;

export default SearchResults;
